//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";
import {analysis} from "../constants";

export default {
  name: "ModelOverviewSidePanel",
  props: {
    selectionName: {
      type: String
    }
  },

  computed: {
    ...mapGetters(["newModel"]),

    selectedProps() {
      return this.newModel[this.selectionName];
    }
  },

  methods: {
    dotClass(severity) {
      switch (severity) {
        case analysis.FATAL:
          return "red";
        case analysis.WARNING:
          return "orange";
        case analysis.NONE:
          return "green";
        default:
          break;
      }
    }
  }
};
